export default "__VITE_ASSET__BHKKsF8r__"